export default "/_next/static/fonts/73499f2fb5eb9691e8f8a1d92ec83f9b.woff";